import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getCookie, setCookie } from '../utils';

export function CookieNotify() {
  const [accept, setAccept] = useState(true);

  const onClose = () => {
    setCookie('policy', 'accept');
    setAccept(true);
  };

  useEffect(() => {
    const isAccept = getCookie('policy');
    if (isAccept) {
      setAccept(true);
    } else {
      setAccept(false);
    }
  }, []);

  if (accept) return null;

  return (
    <div className="cockie_notify">
      <div className="glass">
        <div className="glass_text sm">
          <span>
            На нашем сайте используются файлы cookies, которые делают его более удобным для каждого
            пользователя.
            Посещая страницы сайта, вы соглашаетесь с нашей
            {' '}
            <Link to="/policy">Политикой конфиденциальности</Link>
            .
            Подробнее ознакомиться с тем, для чего именно необходимы файлы сookies, можно
            {' '}
            <Link to="/policy">здесь</Link>
          </span>
        </div>
        <div style={{ alignSelf: 'center' }}>
          <button onClick={onClose} type="button" className="btn btn-sm btn-primary btn-hover-scale">
            ОК
          </button>
        </div>
      </div>
    </div>
  );
}
